import React from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useLang } from "@/lib/lang";

export default function WhatsAppFab({ brand }) {
  const { lang } = useLang();
  if (!brand?.whatsapp) return null;
  const msg = lang === "es"
    ? "Hola El Cuquito, quiero una cotización."
    : "Hi El Cuquito, I'd like a quote.";
  const link = `https://wa.me/1${brand.whatsapp.replace(/\D/g, "")}?text=${encodeURIComponent(msg)}`;
  return (
    <motion.a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 2.4, duration: 0.6, ease: [0.34, 1.56, 0.64, 1] }}
      whileHover={{ scale: 1.1 }}
      className="fixed bottom-6 right-6 md:bottom-10 md:right-10 z-40 w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_20px_60px_rgba(37,211,102,0.55)]"
      aria-label="WhatsApp"
      data-testid="whatsapp-fab"
    >
      <span className="absolute inset-0 rounded-full animate-ping bg-[#25D366] opacity-30" />
      <MessageCircle
        className="text-white relative z-10"
        size={28}
        strokeWidth={2}
      />
    </motion.a>
  );
}
